/**
 * 工具类方法
 */

/**
 * 将"业务功能：64个"  转为 对象
 * {
      num:64,
      unit:个,
      type:业务功能
    };
 */
const strToObj = function (str) {
  let obj = {
    num: "",
    unit: "",
    type: "",
  };
  if (str) {
    let arr = str.split("：");
    obj.type = arr[0];
    if (arr[1]) {
      obj.num = arr[1].substr(0, arr[1].length - 1);
      obj.unit = arr[1].substr(arr[1].length - 1);
    }
  }
  return obj;
};

const pushArr = function (str, arr) {
  if (str) {
    arr.push(strToObj(str));
  }
};

const bindBackground = function (obj, bg) {
  obj.style.background = bg;
};

// const bindHover = function(obj, bg1, bg2) {
//   obj.onmouseover = () => {
//     obj.style.background = bg1;
//   };
//   obj.onmouseout = () => {
//     obj.style.background = bg2;
//   };
// };

const elTabsAddEventListener = function (document, dataSum) {
  let outlineBox = document.querySelector(".outlineBox");
  let leftSpan = outlineBox.querySelector(".el-tabs__nav-prev");
  let rightSpan = outlineBox.querySelector(".el-tabs__nav-next");
  if (!leftSpan || !rightSpan || !leftSpan.children || !rightSpan.children) {
    return;
  }
  let leftI = leftSpan.children[0];
  let rightI = rightSpan.children[0];
  let iLeftBg = "url('img/shang.png') center center / 12px 12px no-repeat";
  let iLeftBgGray =
    "url('img/shang_gray.png') center center / 12px 12px no-repeat";
  let iRightBg = "url('img/xia.png') center center / 12px 12px no-repeat";
  let iRightBgGray =
    "url('img/xia_gray.png') center center / 12px 12px no-repeat";
  // let iLeftBgHover =
  //   "url('img/shang_hover.png') center center / 16px 18px no-repeat";
  // let iRightBgHover =
  //   "url('img/xia_hover.png') center center / 16px 18px no-repeat";
  // let bgNone = "none";
  let perHejght = 110;
  let onePageSize = 5;
  let maxHeight = -(dataSum * perHejght) + 50;
  let transformNum;
  let nextTransformNum;
  let perPageHeight = perHejght * onePageSize;
  leftSpan.addEventListener("click", function () {
    transformNum = parseInt(
      this.nextSibling.nextSibling.firstChild.style.transform
      .split("(")[1]
      .split("px")[0],
      10
    );
    nextTransformNum = transformNum + perPageHeight;
    if (transformNum === 0) {
      bindBackground(leftI, iLeftBgGray);
      bindBackground(rightI, iRightBg);
    } else {
      bindBackground(leftI, iLeftBg);
      bindBackground(rightI, iRightBg);
      if (nextTransformNum < maxHeight) {
        bindBackground(rightI, iRightBgGray);
      }
    }
  });
  rightSpan.addEventListener("click", function () {
    transformNum = parseInt(
      this.nextSibling.firstChild.style.transform.split("(")[1].split("px")[0],
      10
    );
    nextTransformNum = transformNum - perPageHeight;
    if (nextTransformNum < maxHeight) {
      bindBackground(leftI, iLeftBg);
      bindBackground(rightI, iRightBgGray);
    } else {
      bindBackground(rightI, iRightBg);
      bindBackground(leftI, iLeftBg);
      if (nextTransformNum > 0) {
        bindBackground(leftI, iLeftBgGray);
      }
    }
  });
};
const statusTabsAddEventListener = function (document, dataSum) {
  let outlineBox = document.querySelector(".outlineBox");
  let leftSpan = outlineBox.querySelector(".el-tabs__nav-prev");
  let rightSpan = outlineBox.querySelector(".el-tabs__nav-next");
  if (!leftSpan || !rightSpan || !leftSpan.children || !rightSpan.children) {
    return;
  }
  let leftI = leftSpan.children[0];
  let rightI = rightSpan.children[0];
  let iLeftBg = "url('img/prve.png') center center / 13px 26px no-repeat";
  let iLeftBgGray =
    "url('img/prev_gray.png') center center / 13px 26px no-repeat";
  let iRightBg = "url('img/next.png') center center / 13px 26px no-repeat";
  let iRightBgGray =
    "url('img/next_gray.png') center center / 13px 26px no-repeat";
  // let iLeftBgHover =
  //   "url('img/shang_hover.png') center center / 16px 18px no-repeat";
  // let iRightBgHover =
  //   "url('img/xia_hover.png') center center / 16px 18px no-repeat";
  // let bgNone = "none";
  let perHejght = 110;
  let onePageSize = 7;
  let maxHeight = -(dataSum * perHejght) + 50;
  let transformNum;
  let nextTransformNum;
  let perPageHeight = perHejght * onePageSize;
  leftSpan.addEventListener("click", function () {
    transformNum = parseInt(
      this.nextSibling.nextSibling.firstChild.style.transform
      .split("(")[1]
      .split("px")[0],
      10
    );
    nextTransformNum = transformNum + perPageHeight;
    if (transformNum === 0) {
      bindBackground(leftI, iLeftBgGray);
      bindBackground(rightI, iRightBg);
    } else {
      bindBackground(leftI, iLeftBg);
      bindBackground(rightI, iRightBg);
      if (nextTransformNum < maxHeight) {
        bindBackground(rightI, iRightBgGray);
      }
    }
  });
  rightSpan.addEventListener("click", function () {
    transformNum = parseInt(
      this.nextSibling.firstChild.style.transform.split("(")[1].split("px")[0],
      10
    );
    nextTransformNum = transformNum - perPageHeight;
    if (nextTransformNum < maxHeight) {
      bindBackground(leftI, iLeftBg);
      bindBackground(rightI, iRightBgGray);
    } else {
      bindBackground(rightI, iRightBg);
      bindBackground(leftI, iLeftBg);
      if (nextTransformNum > 0) {
        bindBackground(leftI, iLeftBgGray);
      }
    }
  });
};
const elTabsRemoveEventListner = function (document) {
  let outlineBox = document.querySelector(".outlineBox");
  let eles = outlineBox.querySelector(".el-tabs__nav-wrap").children;
  let spanLeft = eles[0];
  let spanRight = eles[1];
  spanLeft.removeEventListener("click");
  spanRight.removeEventListener("click");
};

const userPwdConvert = (str) => {
  let arr = ["用户名：test", "密码：123456"];
  if (str) {
    arr = [];
    let index = str.indexOf("密");
    arr.push(str.substr(0, index));
    arr.push(str.substr(index));
  }
  return arr;
};

const linkToUrlUserPwdArr = (link) => {
  let linkArr = [];
  if (link) {
    let arr = link.split("|");
    let url = arr[1] ? "http://" + arr[1] : "";
    linkArr.push(url);
    if (arr[2]) {
      linkArr = linkArr.concat(userPwdConvert(arr[2]));
    }
  }
  return linkArr;
};

/**
 * 生成大数据，人工智能的课程内容数据
 * 
 * {
  title:"第一章：KettleETL平台（1天）",
  details:[{
      tilte:"课程内容",
      details:["1. 电商行业介绍","2. 大数据数仓项目简介"]
  }]
}
 */
const courseDataConvert = (title, desc) => {
  let obj = null;
  if (title && desc) {
    obj = {
      title: title,
      details: [],
    };
    let arr = desc.split("\n");
    let indexArr = [];
    arr.forEach((item, index) => {
      if (item.indexOf("：") > -1) {
        indexArr.push(index);
      }
    });
    let indexArrLength = indexArr.length;
    for (let i = 0; i < indexArrLength - 1; i++) {
      obj.details.push({
        title: arr[indexArr[i]],
        details: arr.filter(
          (item, index) => index > indexArr[i] && index < indexArr[i + 1]
        ),
      });
    }
    obj.details.push({
      title: arr[indexArr[indexArrLength - 1]],
      details: arr.filter(
        (item, index) => index > indexArr[indexArr.length - 1]
      ),
    });
  }
  return obj;
};

const courseDataToArr = (title, desc, arr = []) => {
  let obj = courseDataConvert(title, desc);
  if (obj) {
    arr.push(obj);
  }
};

const lieBiaoToTeachers = (list, teachers) => {
  if (list && list.length > 0) {
    let arr = list.filter((item) => item.navTitle.indexOf("力量") > -1);
    let lieBiao = arr[0].lieBiao;
    if (lieBiao) {
      let arr = [];
      lieBiao.forEach((item) => {
        arr.push({
          name: item.title,
          quarters: item.subTitle,
          details: item.description,
          headerImage: item.image,
        });
      });
      return arr;
    }
  }
  return teachers;
};

export {
  strToObj,
  elTabsAddEventListener,
  statusTabsAddEventListener,
  elTabsRemoveEventListner,
  userPwdConvert,
  linkToUrlUserPwdArr,
  pushArr,
  courseDataConvert,
  courseDataToArr,
  lieBiaoToTeachers,
};